export default __webpack_public_path__ + "static/media/fatChrostel.9c4fb489.gif";